import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { AlertController, ToastController } from '@ionic/angular';
import { Subscription } from 'rxjs';
import { InventarioService } from '../inventario.service';

/*  LELTÁR – a régi „Készletellenőrzés” utódja: vonalkód-olvasással számolunk (minden olvasás +1),
 *  a számolt és a könyv szerinti készlet egymás mellett (eltérés kiemelve), a „hiányzó” cikkek
 *  (készleten vannak, de nem olvasták be) külön. ÚJ: a lezárás a különbözetet a készletre is
 *  könyveli (leltármozgás) – a régi program ezt nem tette. */
@Component({
  selector: 'app-inventario-leltar',
  templateUrl: './leltar.component.html',
  styleUrls: ['../../naplo/naplo-shared.scss', '../inventario-shared.scss'],
})
export class LeltarComponent implements OnInit, OnDestroy {
  @ViewChild('olvasoMezo') olvasoMezo?: ElementRef<HTMLInputElement>;
  lista: any[] = [];
  raktarak: any[] = [];
  aktiv: any = null;
  olvaso = '';
  utolso = '';
  ujRaktar = '';
  private sub?: Subscription;
  constructor(public inv: InventarioService, private toast: ToastController, private alert: AlertController) {}
  get u() { return this.inv.aktiv.ugyfelId; }
  get ir() { return this.inv.ir; }
  async ngOnInit() { await this.inv.init(); this.sub = this.inv.aktiv$.subscribe(() => this.frissit()); }
  ngOnDestroy() { this.sub?.unsubscribe(); }
  async frissit() {
    this.aktiv = null;
    if (!this.u) return;
    try { this.lista = await this.inv.get(`/leltarak/${this.u}`); this.raktarak = await this.inv.get(`/raktarak/${this.u}`); this.ujRaktar = this.raktarak[0]?.id || ''; } catch { this.lista = []; }
  }
  async indit() {
    try { const r: any = await this.inv.post(`/leltar/${this.u}`, { raktar_id: this.ujRaktar }); await this.nyit({ id: r.id }); await this.frissit(); await this.nyit({ id: r.id }); }
    catch (e: any) { this.hiba(e?.error?.error || 'Nem sikerült.'); }
  }
  async nyit(l: any) {
    try { this.aktiv = await this.inv.get(`/leltar/${this.u}/${l.id}`); setTimeout(() => this.olvasoMezo?.nativeElement.focus(), 100); }
    catch (e: any) { this.hiba(e?.error?.error || 'Nem sikerült megnyitni.'); }
  }
  private async kuld(body: any) {
    const r: any = await this.inv.post(`/leltar/${this.u}/${this.aktiv.id}/olvas`, body);
    this.utolso = r.nev; this.aktiv = await this.inv.get(`/leltar/${this.u}/${this.aktiv.id}`);
  }
  async olvas() {
    const k = this.olvaso.trim(); this.olvaso = '';
    if (!k) return;
    try { await this.kuld({ vonalkod: k }); } catch (e: any) { this.hiba(e?.error?.error || 'Ismeretlen kód.'); }
    this.olvasoMezo?.nativeElement.focus();
  }
  async modosit(t: any, n: number) { try { await this.kuld({ termek_id: t.termek_id, mennyiseg: n }); } catch { /* */ } }
  async beallit(t: any, v: any) { try { await this.kuld({ termek_id: t.termek_id, ertek: v }); } catch { /* */ } }
  async torol(t: any) { try { await this.kuld({ termek_id: t.termek_id, mennyiseg: 0, torol: true }); } catch { /* */ } }
  elteres(t: any): number { return Math.round((Number(t.szamolt) - Number(t.konyv)) * 1000) / 1000; }
  get elteroDb(): number { return (this.aktiv?.tetelek || []).filter((t: any) => this.elteres(t) !== 0).length; }
  async lezar() {
    const a = await this.alert.create({ header: 'Leltár lezárása',
      message: `A számolt és a könyv szerinti készlet különbözete (${this.elteroDb} cikk${this.aktiv.hianyzo.length ? `, + ${this.aktiv.hianyzo.length} be nem olvasott` : ''}) leltármozgásként a készletre könyvelődik.`,
      inputs: this.aktiv.hianyzo.length ? [{ type: 'checkbox', label: 'A be nem olvasott cikkek számolt mennyisége 0 (teljes leltár)', value: 'nulla', checked: false }] : [],
      buttons: [{ text: 'Mégse', role: 'cancel' }, { text: 'Lezárás', handler: async (v: any) => {
        try {
          const r: any = await this.inv.post(`/leltar/${this.u}/${this.aktiv.id}/lezar`, { hianyzo_nulla: Array.isArray(v) && v.includes('nulla') });
          this.ok(r.kulonbozet ? `Lezárva – ${r.kulonbozet} cikk különbözete könyvelve (${r.bizonylatszam}).` : 'Lezárva – nem volt eltérés.');
          await this.frissit();
        } catch (e: any) { this.hiba(e?.error?.error || 'Nem sikerült.'); }
      } }] });
    await a.present();
  }
  szam(v: any) { return v == null ? '' : Number(v).toLocaleString('hu-HU', { maximumFractionDigits: 3 }); }
  private async ok(m: string) { (await this.toast.create({ message: m, duration: 3000, color: 'success' })).present(); }
  private async hiba(m: string) { (await this.toast.create({ message: m, duration: 3500, color: 'danger' })).present(); }
}
